//
import ExtendModel from '@/models/ExtendModel'

//
import AuthorizeModel from '@/models/Actions/AAuthorize'

//
import DetailPurchaseOrderEditedModel from '@/models/Purchase/PchDetailPurchaseOrderEdited'

/**
 * @class
 */
export default class PchPurchaseOrderEdited extends ExtendModel {
    //
    pch_selected_purchase_order_detail = []

    //
    static includes = [
        'pch_purchase_order',
        'pch_purchase_order.pch_detail_purchase_orders.wh_product',
        'pch_purchase_order_state',
        'g_originator_user.hr_employee',
        'g_authorizer_user.hr_employee',
        'pch_detail_purchase_order_editeds.wh_product',
        'pch_detail_purchase_order_editeds.wh_product_service',
    ]

    /**
     * @description
     */
    get g_authorizer_user_full_name() {
        return [
            this.g_authorizer_user.hr_employee.names,
            this.g_authorizer_user.hr_employee.last_name1,
            this.g_authorizer_user.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     * @description
     */
    get can_authorize() {
        return Boolean(this.authorization_date)
    }

    /**
     * @description
     */
    get can_remove() {
        return Boolean(this.authorization_date)
    }

    /**
     * @description
     */
    get g_originator_user_full_name() {
        return [
            this.g_originator_user.hr_employee.names,
            this.g_originator_user.hr_employee.last_name1,
            this.g_originator_user.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     * @description
     */
    get pch_purchase_order_state_name() {
        return this.pch_purchase_order_state
            ? this.pch_purchase_order_state.state
            : '-'
    }

    /**
     *
     */
    get pch_selected_purchase_orders_net_price() {
        return Math.ceil(
            this.pch_detail_purchase_order_editeds.reduce(
                this.reduceNetPrice,
                0
            )
        )
    }

    /**
     *
     */
    get pch_selected_purchase_orders_net_price_str() {
        return '$ ' + this.pch_selected_purchase_orders_net_price
    }

    /**
     * @description
     * wh product service indicator id
     *
     * @type       {number,null}
     */
    get wh_product_service_indicator_id() {
        return this.wh_product_service_indicator ? this.wh_product_service_indicator.wh_product_id : null
    }

    /**
     * @description
     */
    authorize() {
        return this.hasMany(AuthorizeModel)
    }

    /**
     * @description
     */
    mapDetail = item => ({
        net_price: Number(item.net_price),
        provider_product_code: String(item.provider_product_code || '-'),
        quantity: Number(item.quantity),
        wh_product_id: this.is_service ? this.wh_product_service_indicator_id : Number(item.wh_product_id),
        wh_product_service_id: item.wh_product_service_id ? Number(item.wh_product_service_id) : null
    })

    /**
     *
     *
    mapSelected(item) {
        return {
            internal_code: String(item.wh_product.internal_code || '-'),
            id: Number(item.id || 0),
            name: String(item.wh_product.name),
            net_price: Number(item.net_price || 0),
            provider_product_code: String(item.provider_product_code || '-'),
            quantity: Number(item.quantity),
            wh_product: Object(item.wh_product),
            wh_product_id: Number(item.wh_product_id),
            wh_product_service_id: Number(item.wh_product_service_id),
        }
    }*/

    /**
     * @description
     * Mapping raw detail to item class
     *
     * @param      {object}                                          item    The item
     * @return     {(DetailPurchaseOrderEditedModel|Object|string)}  detail purchase order edited class
     */
    mapSelected = item => new DetailPurchaseOrderEditedModel(item)

    /**
     *
     */
    reduceNetPrice(total, current) {
        return (
            Number(total) + Number(Number(current.net_price) * current.quantity)
        )
    }

    /**
     * @description
     */
    reset() {
        //
        if (this.pch_detail_purchase_order_editeds) {
            this.pch_selected_purchase_order_detail = this.pch_detail_purchase_order_editeds.map(
                this.mapSelected
            )
        }

        //
        //console.log(this.pch_selected_purchase_order_detail)

        //
        return this
    }

    /**
     * @description
     */
    resource() {
        return 'pch_purchase_order_edited'
    }

    /**
     * @description
     */
    toCreate() {
        //
        this.details = this.pch_selected_purchase_order_detail.map(
            this.mapDetail
        )

        //
        return this.clean(['details', 'pch_purchase_order_id'])
    }
}
